import React from 'react';
import styled from 'styled-components';
import {GetCardTypeForBody} from '../../../../../util/utils';
import Utility from '../../../../../util/utilityfunctions';

function PrintViewDefaultBody(props) {
	// Props:
	const {body} = props;

	const formBodyBorder = GetCardTypeForBody(body);

	return (
		<StyledPrintViewDefaultBody className={`StyledPrintViewDefaultBody ${formBodyBorder}`}>
			<span> {Utility.getHtmlTextElement(body.name, true)}</span>
		</StyledPrintViewDefaultBody>
	);
}

export default PrintViewDefaultBody;

const StyledPrintViewDefaultBody = styled.section``;
